import AssignmentIcon from '@mui/icons-material/Assignment';
import TaskList from './TaskList';
import TaskCreate from './TaskCreate';
import TaskEdit from './TaskEdit';
import TaskShow from './TaskShow';

const tasks = {
    list: TaskList,
    create: TaskCreate,
    edit: TaskEdit,
    show: TaskShow,
    icon: AssignmentIcon
};

export default tasks;
